import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const steps = ['Explore the 6 volumes.', 'Review the planning maps.', 'Use the checklists.', 'Test the trackers.', 'Organize a case.'];
export function GuaranteeSection() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-129" data-mp="etpo8kavi8iy">
      <div className="mx-auto w-full max-w-2xl" data-id="element-130" data-mp="er36xsy6kenj">
        <div className="rounded-3xl border border-cta/25 bg-skysoft p-6 sm:p-9" data-id="element-131" data-mp="jrhhbhn980oq">
          <div className="flex flex-col items-center text-center" data-id="element-132" data-mp="ntm90au56n8q">
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-cta shadow-lg shadow-cta/25" data-id="element-133" data-mp="nrrmwt74wp32">
              <ShieldCheckIcon className="h-7 w-7 text-white" aria-hidden="true" data-id="element-134" data-mp="xjnuqvz0vtkh" />
            </span>
            <p className="mt-4 text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-cta" data-id="element-135" data-mp="12kldparuwrn1">
              7-day guarantee
            </p>
            <h2 className="mt-3 text-[23px] font-black leading-tight text-navy sm:text-3xl" data-id="element-136" data-mp="25rniaxguqis8">
              Try Aligner Treatment Blueprint™ for 7 days
            </h2>
          </div>

          <ul className="mt-7 space-y-2.5" data-id="element-137" data-mp="20v6szzxx1ydk">
            {steps.map(step => <li key={step} className="flex items-center gap-2.5 rounded-xl bg-white px-3.5 py-3" data-id="element-138" data-mp="1vu0xjucvfx0c">
                <CheckIcon className="h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-139" data-mp="2oiy5b3jgibeu" />
                <span className="text-[13.5px] font-semibold text-navy sm:text-[15px]" data-id="element-140" data-mp="2eslonmerj2dz">
                  {step}
                </span>
              </li>)}
          </ul>

          <p className="mt-6 text-center text-[13.5px] leading-relaxed text-navy2 sm:text-[15px]" data-id="element-141" data-mp="2aoxeqx2nrupk">
            If within 7 days you decide that ALIGNER TREATMENT BLUEPRINT™ isn’t
            the right fit for your professional workflow, you can request a
            refund according to the terms of the offer.
          </p>

          <div className="mx-auto mt-8 max-w-md" data-id="element-142" data-mp="15jh340lbmfrb">
            <CtaButton label="Try it risk-free for 7 days" subLabel="$27 one-time · Automatic currency conversion" data-id="element-143" data-mp="15j7bk8kmo0ji" />
          </div>
        </div>
      </div>
    </section>;
}